import React, { useEffect, useRef } from "react";

const SaveToDropbox = ({ files, enableBtn }) => {
    const buttonRef = useRef(null);

    useEffect(() => {
        if (window.Dropbox && buttonRef.current) {
            window.Dropbox.createSaveButton(
                {
                    files: files,
                },
                buttonRef.current
            );
        }
    }, []);

    return <em ref={buttonRef} className={`dropbox-dropin-btn dropbox-dropin-default dropbox-saver ${enableBtn ? "" : "disable_download"}`}><span className="dropin-btn-status">
        </span> Save to Dropbox</em>
};

export default SaveToDropbox;
